/**
 * The "Want more money" button files a plain admin action whose only marker is
 * its message text. Detecting it here is what lets the Actions list send the
 * admin straight to the salary screen instead of the profile page.
 *
 * Mirrored on the back end in be/src/utils/raiseRequest.ts -- the packages share
 * no module, so the constant is duplicated under the same name in both, as
 * ADMIN_DELETE_WINDOW_DAYS already is. Same name in both so grep finds them
 * together.
 */
export const RAISE_REQUEST_PHRASE = 'wants more money';

export const isRaiseRequest = (message: string | undefined) => (
  Boolean(message) && message!.toLowerCase().includes(RAISE_REQUEST_PHRASE)
);

export default isRaiseRequest;
